<template>
  <div :class="[isScrolledTable && 'table-main__wrapper']">
    <div
      :class="['table-main', isScrolledTable && 'table-main--scrolled']"
      :style="{gridTemplateRows: `repeat(${titles.length}, auto)`}"
    >
      <slot></slot>

      <div
        v-if="isScrolledTable && $nuxt.$breakpoints.sMd"
        class="table-main__empty-column"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableMain',
  props: {
    titles: {
      type: Array,
      required: true
    },
    isScrolledTable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.table-main {
  position: relative;
  display: grid;
  grid-auto-columns: 1fr;
  grid-auto-flow: column;
  width: 100%;

  @media (max-width: $breakpoint-lg) {
    grid-template-rows: none !important;
    grid-auto-flow: row;
    grid-row-gap: 20px;
  }
}

.table-main--scrolled {
  @media (max-width: $breakpoint-lg) {
    margin-left: -6px;
    grid-auto-flow: column;
    grid-column-gap: 10px;
    grid-auto-columns: calc(100% / 12 * 5 + 6px);
  }

  @media (max-width: $breakpoint-md) {
    grid-auto-columns: 302px;
  }

  @media (max-width: $breakpoint-xs) {
    grid-auto-columns: 276px;
  }
}

.table-main--scrolled .table-column {
  @media (max-width: $breakpoint-lg) {
    margin-left: 6px;
    justify-content: space-between;
  }
}

.table-main__wrapper {
  @media (max-width: $breakpoint-lg) {
    margin: 0 -10px;
    padding: 0 10px;
    width: calc(100% + 20px);

    overflow-x: scroll;
    overflow-y: hidden;
  }
}

.table-main .ant-input-number {
  min-width: auto;
}

.table-main .ant-checkbox-wrapper {
  color: inherit;

  @media (max-width: $breakpoint-lg) {
    flex-direction: column;
  }
}

.table-main .ant-checkbox {
  @media (max-width: $breakpoint-lg) {
    margin-bottom: 16px;
  }
}

.table-main .ant-checkbox + span {
  @media (max-width: $breakpoint-lg) {
    padding-left: 0;
  }
}

.table-main ul {
  padding: 0;
  list-style: none;
}

.table-main li {
  margin-bottom: 8px;

  &:before {
    content: '—';
    margin-right: 8px;
  }
}

.table-main__empty-column {
  display: none;

  @media (max-width: $breakpoint-lg) {
    display: block;
    width: 1px;
  }
}
</style>